"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnAlternateDDRecommendation = exports.getMinimumRecommendedAmount = exports.nextScheduleDay = exports.addLeadingZeros = exports.createConfirmParamsKapi = exports.createConfirmParams = exports.formatFromEpochDays = exports.getPoundValueAsNumber = exports.isAmountInRange = exports.recDdApproxEqualToCurrentDd = exports.recommendedDirectDebitAsNumber = void 0;
var date_fns_1 = require("date-fns");
var money_1 = require("../../../shared/core/utils/money");
var constants_1 = require("../constants");
var recommendedDirectDebitAsNumber = function (recommendedDirectDebit) {
    return recommendedDirectDebit && recommendedDirectDebit.friendlyAmount
        ? (0, exports.getPoundValueAsNumber)(recommendedDirectDebit.friendlyAmount)
        : 0;
};
exports.recommendedDirectDebitAsNumber = recommendedDirectDebitAsNumber;
var recDdApproxEqualToCurrentDd = function (friendlyAmount, currentAmount) {
    return (friendlyAmount != null &&
        Math.abs((0, money_1.getCurrencyValueAsNumber)({ unit: 'GBP' }, currentAmount) -
            (0, money_1.getCurrencyValueAsNumber)({ unit: 'GBP' }, friendlyAmount)) < 5);
};
exports.recDdApproxEqualToCurrentDd = recDdApproxEqualToCurrentDd;
function isAmountInRange(amount, minimumAmount) {
    var amountNum = Number(amount);
    return amountNum >= minimumAmount && amountNum <= constants_1.MAX_DD_AMOUNT;
}
exports.isAmountInRange = isAmountInRange;
exports.getPoundValueAsNumber = money_1.getCurrencyValueAsNumber.bind({}, { unit: 'GBP' });
var formatFromEpochDays = function (epochDays) {
    var date = new Date(epochDays * 24 * 60 * 60 * 1000);
    return (0, date_fns_1.format)(date, 'yyyy-MM-dd');
};
exports.formatFromEpochDays = formatFromEpochDays;
var createConfirmParams = function (_a) {
    var newAmount = _a.newAmount, upcomingPayments = _a.upcomingPayments;
    return new URLSearchParams(__assign({ amount: newAmount.amount }, (upcomingPayments && upcomingPayments.length
        ? {
            upcomingPaymentAmount: upcomingPayments[0].amount.amount,
            upcomingPaymentDate: (0, exports.formatFromEpochDays)(upcomingPayments[0].date),
            futureUpcomingPaymentDate: (0, exports.formatFromEpochDays)(upcomingPayments[1].date),
        }
        : {}))).toString();
};
exports.createConfirmParams = createConfirmParams;
var createConfirmParamsKapi = function (_a) {
    var amount = _a.amount, scheduleDay = _a.scheduleDay;
    return new URLSearchParams({
        amount: amount,
        scheduleDay: String(scheduleDay),
    }).toString();
};
exports.createConfirmParamsKapi = createConfirmParamsKapi;
function addLeadingZeros(num) {
    return String(num).padStart(2, '0');
}
exports.addLeadingZeros = addLeadingZeros;
function nextScheduleDay(scheduleDay) {
    var today = (0, date_fns_1.getDate)(new Date());
    var thisMonth = (0, date_fns_1.getMonth)(new Date()) + 1; // who zero-indexes months?
    var nextMonth = (0, date_fns_1.getMonth)((0, date_fns_1.addMonths)(new Date(), 1)) + 1;
    var thisYear = (0, date_fns_1.getYear)(new Date());
    // Note: Safari falls over without leading zeros on month or day
    // if today less than schedule
    // this month
    if (Number(today) < Number(scheduleDay)) {
        return (0, date_fns_1.format)("".concat(thisYear, "-").concat(addLeadingZeros(thisMonth), "-").concat(addLeadingZeros(Number(scheduleDay))), 'd MMM');
    }
    else {
        // return next month if schedule is before today
        // or they're equal (although equal shouldn't have been able to change date)
        return (0, date_fns_1.format)("".concat(thisYear, "-").concat(addLeadingZeros(nextMonth), "-").concat(addLeadingZeros(Number(scheduleDay))), 'd MMM');
    }
}
exports.nextScheduleDay = nextScheduleDay;
var getMinimumRecommendedAmount = function (paymentRecommendation) {
    if (Number(paymentRecommendation.roundedRecommendationAmount) >
        Number(paymentRecommendation.minimumRecommendationAmount)) {
        return Number(paymentRecommendation.roundedRecommendationAmount);
    }
    else {
        return Number(paymentRecommendation.minimumRecommendationAmount);
    }
};
exports.getMinimumRecommendedAmount = getMinimumRecommendedAmount;
function isOnAlternateDDRecommendation(calculationEndDate) {
    return (calculationEndDate !== null &&
        (calculationEndDate.getMonth() !== 2 || calculationEndDate.getDate() !== 31));
}
exports.isOnAlternateDDRecommendation = isOnAlternateDDRecommendation;
